import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
     CircularProgress,
    FormControlLabel,
    FormHelperText,
    FormLabel,
     LinearProgress,
     Radio, RadioGroup,

    TextField
} from "@material-ui/core";
import IntlMessages from "../util/IntlMessages";
import {useForm} from "react-hook-form";
import { mfaCloseRegistrationForm,
    mfaRegisterDelete,
    mfaRegisterWithForm, mfaVerify
} from "../actions";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import BBExternalLink from "../components/customBreachBits/accents/BBExternalLink";
import QRCode from "react-qr-code";
import BBIconCircleRightChevron from "../assets/bbCustomIcons/BBIconCircleRightChevron";
import BBIconCheckCircleYes from "../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconEmail from "../assets/bbCustomIcons/BBIconEmail";
import BBIconSMSText from "../assets/bbCustomIcons/BBIconSMSText";
import BBIconCallPhone from "../assets/bbCustomIcons/BBIconCallPhone";
import BBIconQRCodeOTP from "../assets/bbCustomIcons/BBIconQRCodeOTP";
import {Redirect, useHistory} from "react-router-dom";
import countryCodesArray from "../constants/CountryCodeArray"
import {InputAdornment, MenuItem} from "@mui/material";
import {Col, Row} from "reactstrap";
import {isCurrentUserMemberOf} from "../util/bbHelpers";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 400,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            // width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const history = useHistory();
  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {authUser, token,loadingMFARegister, loadingMFAVerify, mfaRegisterError, loadingMFARegisterDelete,} = useSelector(({auth}) => auth);
    const {didJustVerifyForMFA,  mfaOtpQrcodeUrl, didJustRegisterForMFA, mfaFormUserMessage} = useSelector(({auth}) => auth.appMisc);
  const dispatch = useDispatch();

  const isMFAEnabled = authUser && authUser.security ? authUser.security.mfa_enabled : null;
  const isAdmin = isCurrentUserMemberOf(authUser, "admin")


    // const [customerId, setCustomerId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [preference, setPreference] = useState(0);
    const [mfaPhone, setMfaPhone] = useState(null);
    const [countryCode, setCountryCode] = useState("+1");
    const [mfaVerificationCode, setMfaVerificationCode] = useState(null);
    const [skipRegistrationStep, setSkipRegistrationStep] = useState(false);
    const [showRegistrationStepEvenIfJustSubmitted, setShowRegistrationStepEvenIfJustSubmitted] = useState(false);


    const clearForm = () => {
        setUserId("");
        // const tempCustomerId = customerId;
        const registrationForm = document.getElementById('MFARegistrationForm');
        if(registrationForm) {
            registrationForm.reset();
        }
        setMfaVerificationCode(null);
        setPreference(0);
        setMfaPhone(null);
        setCountryCode("1")
        setSkipRegistrationStep(null);
        setSkipRegistrationStep(false);
        setShowRegistrationStepEvenIfJustSubmitted(false);
    }

  useEffect(() => {
    if(didJustVerifyForMFA) {
        clearForm();
       if(!token){
           history.push('/signin')
       } else if((authUser && authUser.customers && Array.isArray(authUser.customers) && authUser.customers.length === 0) && !isAdmin) {
           console.log("User signed in without any customers associated. Directing user to /confirmNew")
           history.push(`/confirmNew`)
       } else{
           history.push('/')
       }

    }
  }, [dispatch, didJustRegisterForMFA, didJustVerifyForMFA, loadingMFARegister, loadingMFARegisterDelete, mfaRegisterError, skipRegistrationStep]);

    // const { register, handleSubmit, errors } = useForm();
    const registrationFormHooks = useForm();
    const verificationFormHooks = useForm();

    const onSubmitRegistration = data => {
        // setLocalLoading(true);
        console.log("Dispatching mfaRegisterWithForm", data, "skipRegistrationStep", skipRegistrationStep, "didJustRegisterForMFA", didJustRegisterForMFA, "showRegistrationStepEvenIfJustSubmitted", showRegistrationStepEvenIfJustSubmitted);
        dispatch(mfaRegisterWithForm(userId, preference, countryCode + mfaPhone));
        modifyRegistrationStepEvenIfJustSubmitted(false);
    }

    const onSubmitVerification = data => {
        // setLocalLoading(true);
        console.log("Dispatching mfaVerify form", data, "skipRegistrationStep", skipRegistrationStep, "didJustRegisterForMFA", didJustRegisterForMFA, "showRegistrationStepEvenIfJustSubmitted", showRegistrationStepEvenIfJustSubmitted);
        dispatch(mfaVerify(userId, mfaVerificationCode));
    }

    const lostCodeRestartRegistration = () => {
        console.log("lostCodeRestartRegistration", "skipRegistrationStep", skipRegistrationStep, "didJustRegisterForMFA", didJustRegisterForMFA, "showRegistrationStepEvenIfJustSubmitted", showRegistrationStepEvenIfJustSubmitted);

        //send delete call if they are not enrolled.
        //TODO: only send this if they have not done step

        dispatch(mfaRegisterDelete(userId));

        //send the form back
        setSkipRegistrationStep(false);
    }

    const disableMFA = () => {
        console.log("disableMFA");

        //send delete call?
        dispatch(mfaRegisterDelete(userId));
        dispatch(mfaCloseRegistrationForm());
    }

    const modifyRegistrationStep = (newState) => {
        console.log("modifyRegistrationStep", newState, "skipRegistrationStep",skipRegistrationStep, "didJustRegisterForMFA", didJustRegisterForMFA, "showRegistrationStepEvenIfJustSubmitted", showRegistrationStepEvenIfJustSubmitted);
        setSkipRegistrationStep(newState);
        setMfaVerificationCode(null);
    }

    const modifyRegistrationStepEvenIfJustSubmitted = (newState) => {
        console.log("showRegistrationStepEvenIfJustSubmitted", newState, "skipRegistrationStep",skipRegistrationStep, "didJustRegisterForMFA", didJustRegisterForMFA, "showRegistrationStepEvenIfJustSubmitted", showRegistrationStepEvenIfJustSubmitted);
        setShowRegistrationStepEvenIfJustSubmitted(newState);
    }

    // const onMasqueradeAsUserSubmit = data => {
    //     dispatch(masqueradeAsUser(userId, token, refreshToken));
    // }
    // console.log("This is preference", preference, "this is mfaPhone", mfaPhone, "type of mfaPhone", typeof mfaPhone ,"this is countryCode", countryCode, "type of country code", typeof countryCode, "countryCode + mfaPhone", countryCode + mfaPhone)

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const registrationForm = <form id={"MFARegistrationForm"} className="animated fadeIn animation-duration-7">
            <h2>Step 1 of 2: Register

                <LinearProgress variant={"determinate"} value={50} className={"max-width-25p"}/>

            </h2>

            <p>Select your preferred authentication method and provide your phone number as a backup authentication method.</p>
            <div className={"row"}>
                <div className={"col-12"}>

                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label"><IntlMessages id="appModule.mfa.register.preference"/></FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            id="preference"
                            name="preference"
                            value={preference}
                            required
                            onChange={(event) => setPreference(event.target.value)}
                        >
                            <FormControlLabel value="0" control={<Radio checked={!preference || preference==="0"}/>} label={<><BBIconQRCodeOTP/> One-Time Passcode (e.g. <BBExternalLink href={"https://apps.apple.com/us/app/totp-authenticator-fast-2fa/id1404230533"} tipText={"Learn more about TOTP the Apple App Store in a new tab."}>TOTP</BBExternalLink> or <BBExternalLink href={"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"} tipText={"Read about Google Authenticator app in the Google Play store in a new tab."}> Google Authenticator</BBExternalLink> apps)</>} />
                            <FormControlLabel value="3" control={<Radio />} label={<><BBIconEmail/> Email (the email associated with your BreachBits account will be used)</>} />
                            <FormControlLabel value="1" control={<Radio />} label={<><BBIconSMSText/> SMS</>} />
                            <FormControlLabel value="2" control={<Radio />} label={<><BBIconCallPhone/> Phone Call</>} />
                        </RadioGroup>

                        <FormHelperText
                            error={!!registrationFormHooks.errors.preference}
                        >
                            {registrationFormHooks.errors.preference? registrationFormHooks.errors.preference?.message : " "}
                        </FormHelperText>
                    </FormControl>
                    <br/>
                    <Row>
                        <Col sm={4} lg={4}>
                            <TextField
                                label={<IntlMessages id="appModule.mfa.register.country"/>}
                                id={"countryCode"}
                                name={"countryCode"}
                                select
                                required
                                style={{width: "100%"}}
                                error={!!registrationFormHooks.errors.countryCode}
                                // onChange={(event) => setCountryCode(event.target.value)}
                                onChange={(event) => setCountryCode(event.target.value)}
                                defaultValue={"+1"}
                                margin={"normal"}
                                className={""}
                                helperText={!registrationFormHooks.errors.countryCode &&<>Please select a country calling code to register.</>}
                            >
                                {countryCodesArray.map((option)=>(
                                    <MenuItem className={"text-center"} key={option.iso} value={option.code}>
                                        {option.country}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Col>
                        <Col>
                            <TextField
                                label={<IntlMessages id="appModule.mfa.register.phone"/>}
                                // fullWidth
                                id="mfaPhone"
                                name="mfaPhone"
                                required
                                error={!!registrationFormHooks.errors.mfaPhone}
                                onChange={(event) => setMfaPhone(event.target.value)}
                                defaultValue={`${mfaPhone ? mfaPhone : ""}`}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={registrationFormHooks.register({
                                    required: <>Required and must include your <BBExternalLink tipText={"Find your Country Calling code on Wikipedia in a new tab"} href={"https://en.wikipedia.org/wiki/List_of_country_calling_codes#Alphabetical_listing_by_country_or_region"}>Country Calling code</BBExternalLink> without spaces. ex: 112345678901 or +112345678901</> ,
                                    pattern: /^\+?[1-9][0-9]{1,14}$/

                                })}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">{countryCode ? `${countryCode}` : "+1"}</InputAdornment>,
                                }}
                                style={{width: "100%"}}
                                helperText={(!registrationFormHooks.errors.mfaPhone && <>Used to send SMS or Phone call, and as a backup to OTP and Email methods.</>)
                                    // Include <BBExternalLink tipText={"Find your Country Calling code on Wikipedia in a new tab"} href={"https://en.wikipedia.org/wiki/List_of_country_calling_codes#Alphabetical_listing_by_country_or_region"}>Country Calling code</BBExternalLink> ex: 11234567890 or +11234567890</>)
                                    || (registrationFormHooks.errors.mfaPhone?.type === "pattern" && <>Please enter a valid phone number without spaces. ex: 11234567890 or +11234567890</>)
                                    || registrationFormHooks.errors.mfaPhone?.message}
                            />
                        </Col>
                    </Row>




                    <div>

                        <Button onClick={registrationFormHooks.handleSubmit(onSubmitRegistration)}
                                disabled={!!registrationFormHooks.errors.preference || !!registrationFormHooks.errors.mfaPhone}
                                variant="contained" color="primary"
                                endIcon= {<BBIconCircleRightChevron />}
                                className={"m-2"}
                                type={"submit"}
                        >
                            <IntlMessages id="form.next"/>

                        </Button>{loadingMFARegister && <CircularProgress size={26}/>}
                    </div>
                    <div>

                        <Button
                            variant={"contained"}
                            onClick={() => {
                                modifyRegistrationStep(true);
                                modifyRegistrationStepEvenIfJustSubmitted(false);
                            }}
                            className={"m-2"}
                        >
                            Enter Verification Code
                        </Button>
                        <em>A verification code was already sent to me.</em>
                    </div>
                    <div>

                        <Button
                            variant={"contained"}
                            onClick={lostCodeRestartRegistration}
                            className={"m-2"}
                        >
                            Restart Registration
                        </Button>
                        <em>I have lost the code.</em>
                    </div>

                </div>
            </div>
        </form>

    const verificationForm = <form id={"MFAVerificationForm"} className="animated fadeIn animation-duration-7">
            <h2>Step 2 of 2: Verify
                <LinearProgress variant={"determinate"} value={100} className={"max-width-25p"}/>
            </h2>


            {mfaOtpQrcodeUrl
                ? <><p>Scan this QR code with your Authenticator App. This ensures that you provided your information correctly and that MFA is ready for use.</p><QRCode value={mfaOtpQrcodeUrl}/></>
                : <p>Verify your selected authentication method by providing the 6-digit code that was sent to you. This ensures that you provided your information correctly and that MFA is ready for use.</p>
            }
            <div className={"row"}>
                <div className={"col-12"}>
                    <TextField
                        label={<IntlMessages id="appModule.mfa.verify.authCode"/>}
                        // fullWidth
                        id="mfaVerificationCode"
                        name="mfaVerificationCode"
                        required
                        autoComplete={"off"}
                        autoFocus
                        error={!!verificationFormHooks.errors.mfaVerificationCode}
                        onChange={(event) => setMfaVerificationCode(event.target.value)}
                        defaultValue={mfaVerificationCode}
                        margin="normal"
                        className="mt-1 my-sm-3"
                        inputRef={verificationFormHooks.register({
                            required: <>Required. {mfaFormUserMessage}</> ,
                            pattern: /^[0-9]{6}$/

                        })}
                        helperText={(!verificationFormHooks.errors.mfaVerificationCode && <>A 6-digit code was sent to you. {mfaFormUserMessage}</>) || (verificationFormHooks.errors.mfaVerificationCode?.type === "pattern" && <>Invalid Format {mfaFormUserMessage}</>) || verificationFormHooks.errors.mfaVerificationCode?.message}
                    />


                    <div>

                        <Button onClick={verificationFormHooks.handleSubmit(onSubmitVerification)}
                                disabled={!!verificationFormHooks.errors.mfaVerificationCode}
                                variant="contained" color="primary"
                                endIcon={<BBIconCheckCircleYes />}
                                className={"m-2"}
                                type={"submit"}
                        >
                            <IntlMessages id="form.verify"/>
                        </Button>{loadingMFAVerify && <CircularProgress size={26}/>}
                        {/*{localLoading && <CircularProgress size={30}/>}*/}
                    </div>
                    {!mfaOtpQrcodeUrl &&
                        <div>

                            <Button
                                variant={"contained"}
                                onClick={() => {
                                        modifyRegistrationStep(false);
                                        modifyRegistrationStepEvenIfJustSubmitted(true);
                                    }
                                }
                                className={"m-2"}
                            >
                                Go Back to Registration
                            </Button>
                            <em>I have not been sent a verification code.</em>
                        </div>
                    }
                    <div>

                        <Button
                            variant={"contained"}
                            onClick={lostCodeRestartRegistration}
                            className={"m-2"}
                        >
                            Restart Registration
                        </Button>
                        <em>I have lost the code or the code does not work.</em>
                    </div>

                </div>
            </div>
        </form>

    const mfaIsAlreadyEnabledForm = <div>

        <div>
            <h2>MFA is already enabled</h2>

        <Button
            variant={"contained"}
            onClick={disableMFA}
            className={"m-2"}
            color={"primary"}
        >
            Disable MFA
        </Button>
        <em>You can re-enable this but will be required to set up MFA again.</em>
    </div>
    </div>

    return (
        <div className="animated fadeIn animation-duration-7">

            {isMFAEnabled
                ? mfaIsAlreadyEnabledForm
                : ((!didJustRegisterForMFA && !skipRegistrationStep) || showRegistrationStepEvenIfJustSubmitted)
                    ? registrationForm
                    : verificationForm
            }

        </div>
    );



}

export default Form